import {
	Component,
	Input,
	OnInit
} from '@angular/core';

import { ISortedEvent } from 'rev-shared/ui/sortable/VbUiSortable.Directive';
import { IWebcastViewContext } from 'rev-shared/webcast/webcastView/IWebcastViewContext';

import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

import { Question, QuestionContext } from './Question';
import { WebcastViewQuestionsService } from './WebcastViewQuestions.Service';
import './VbWebcastQuestionsList.Component.less';

@Component({
	selector: 'vb-webcast-questions-list',
	templateUrl: './VbWebcastQuestionsList.Component.html',
	standalone: false
})
export class VbWebcastQuestionsListComponent implements OnInit {
	@Input() public allowReordering: boolean;
	@Input() public context: IWebcastViewContext;
	@Input() public questionContext: QuestionContext;
	@Input() public questions: Question[];
	@Input() public webcast: WebcastModel;

	public readonly sortableOptions = {
		handle: '.drag-handle',
		axis: 'y'
	};
	public canModerate: boolean;

	constructor(
		private readonly WebcastViewQuestionsService: WebcastViewQuestionsService
	){}

	public ngOnInit(): void {
		this.canModerate = this.webcast.currentUser.canManageQuestions;
	}

	public onSort(event: ISortedEvent): void {
		const fromItem = this.questions[event.oldIndex];
		const toItem = this.questions[event.newIndex];

		this.WebcastViewQuestionsService.reorderQuestions(this.webcast.id, fromItem, toItem);
	}

	public trackByQuestionNumber(_, question: Question): number {
		return question.questionNumber;
	}
}
